import React from 'react';
import { cl } from '../../components/utils/utils';

// Example of a collapsible section:
// {
//   "type": "collapsibleSection",
//   "customProps": {
//     "title": "Section Settings",
//     "defaultOpen": true,
//     "controlCount": 2,
//     "float": "left",
//     "width": "100%",
//     "box": true,
//     "className": "my-class",
//     "clear": true
//   }
// }

class CollapsibleSection extends React.Component {
  constructor(props) {
    super(props);
//     cl(props);
    this.props.getValue(props.ind, { type: 'local' });
  }

  render() {
    const { ind, custom = {}, children } = this.props;
    const {
      title = 'Section',
      defaultOpen = false,
      float,
      leftMargin,
      width,
      box,
      customCss,
      className,
    } = custom;

    const style = {};
    if (float) style.float = float;
    if (leftMargin != null) style.marginLeft = leftMargin;
    if (width != null) style.width = width;
    if (box) {
      style.borderStyle = 'solid';
      style.borderWidth = 1;
      style.borderRadius = 10;
      style.padding = 20;
    }
    if (customCss) Object.assign(style, customCss);

    const toggleId = `collapse-sect-${ind}`;
    const isDefaultCollapsed = defaultOpen === false;

    return (
      <div
        className={`collapsible-section ${className || ''}`.trim()}
        style={style}
        id={`sect${ind}`}
      >
        <input
          type="checkbox"
          id={toggleId}
          className="collapse-toggle"
          defaultChecked={isDefaultCollapsed}
        />
        <label className="collapse-header" htmlFor={toggleId}>
          {title}
        </label>
        <div className="collapse-content">{children}</div>
      </div>
    );
  }
}

export default CollapsibleSection;
